import { type ConversationTurnItemConstructor } from '../../../value-objects/ConversationTurnItem'
import { type IConversationRepository } from '../../interfaces/IConversationRepository'

interface Dependency {
  conversationRepository: IConversationRepository
}

export class ResumeConversationUseCase {
  constructor(private readonly deps: Dependency) {}

  execute = (
    conversationId: string
  ): Promise<ConversationTurnItemConstructor[]> =>
    this.deps.conversationRepository.resume(conversationId)
}
